<template>
  <div>
    <page-loading v-if="!item" />
    <b-row v-if="item">
      <b-col>
        <page-title :title="pageTitle" />
        <b-link :to="allergensUrl">View Allergens</b-link>
      </b-col>
    </b-row>
    <b-row v-if="item">
      <b-col>
        <content-block name="StationDetails" :tokens="item" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "StationDetails",
  mixins: [
    CrudOperationsMixin
  ],
  props: [
      'id'
  ],
  data() {
    return {
      item: null,
    };
  },
  computed: {
    pageTitle: function () {
      return 'Counting Station Information: ' + this.item.displayCity + ', ' + this.item.state;
    },
    allergensUrl: function () {
      return '/station/' + this.id;
    }
  },
  methods: {
    load: function () {
      this.readQuery('/graphql/public', {
          query: `
            query ($id: ID) {
              station (id: $id) {
                address1,
                address2,
                city,
                country,
                displayCity,
                faxNumber,
                headName,
                headEmail,
                name,
                name2,
                phoneNumber,
                postalCode,
                state,
                website
              }
            }`,
          variables: {
            'id': this.id
          }
        }, (data) => {
          this.item = data.station;
        });        
    }    
  },
  mounted () {
    this.load();
  }
};
</script>